// reelConfig.ts

export const REEL_COLLECTION_COUNT = 2;
export const REEL_NUMBERS = 5;
export const SYMBOLS_PER_REEL = 5;
export const SYMBOL_WIDTH = 161;
export const SYMBOL_HEIGHT = 170;
export const REEL_WIDTH = SYMBOL_WIDTH;
export const REEL_DIVIDER = 9;//2;
export const REEL_FRAME = 0;
export const NUMBER_OF_SYMBOLS = 11;
export const SHOWN_REELS_HEIGHT = SYMBOL_HEIGHT * SYMBOLS_PER_REEL;
export const MULTI_POS = 50;

//multipliers
// export const MULTIPLIER1_FONT = 70;
// export const MULTIPLIER2_FONT = 40;
// export const MULTIPLIER1_POS = { x: 498, y: -92 };
// export const MULTIPLIER2_POS = { x: 689, y: -76 };
// export const MULTIPLIER3_POS = { x: 820, y: -69 };
// export const MULTIPLIER4_POS = { x: 952, y: -62 };

export const SCATTER_ID = 12;
export const PAYLINE_SPINE_X = 433;
export const PAYLINE_SPINE_Y = 372;

// import { TextStyle } from "pixi.js";

// export const WILD_MULT_STYLE = new TextStyle({
//     fontFamily: 'Arial',
//     fontSize: 100,
//     fill: "#fed716",
//     fontWeight: "bold",
//     stroke: '#4a1850',
//     dropShadow: true,
// });